import {PrepMigration, PrepMigrationResolution} from "../../../../api/QuoteHardware";
import {
    Alert,
    Button,
    DialogContent,
    DialogTitle,
    Grid,
    Table,
    TableCell, TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import React, {useEffect, useState} from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from "@mui/icons-material/Edit";

export function PrepErrorResolver(props: {
    mainError: string;
    value: PrepMigrationResolution | null | any;
    onSetupRule(resolution: PrepMigration): void;
}) {
    const [show, setShow] = useState(true);
    const value = getMigration(props.value);

    useEffect(() => {
        if(value) setShow(true);
    }, [value]);

    if(!show) return null;
    if(!value) return null;

    const submit = () => {
        const v = value?.prepMigrationResolution;
        if(v) {
            props.onSetupRule(v);
        }
    };

    return (<Dialog2 open onClose={() => setShow(false)} onEnterPress={submit}>
        <DialogTitle>
            Check Product Change Validation
        </DialogTitle>
        <DialogContent>

            <Alert severity="error">
                {props.mainError}
            </Alert>

            <div style={{height: 16}} />

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox">
                        </TableCell>
                        <TableCell>Prep Changes</TableCell>
                    </TableRow>
                </TableHead>
                {(value.prepMigrationResolution.addDescription || []).map(a => <TableRow key={"add." + a}>
                    <TableCell padding="checkbox">
                        <AddCircleIcon />
                    </TableCell>
                    <TableCell>{a}</TableCell>
                </TableRow>)}
                {(value.prepMigrationResolution.removeDescription || []).map(a => <TableRow key={"remove." + a}>
                    <TableCell padding="checkbox">
                        <RemoveCircleIcon />
                    </TableCell>
                    <TableCell>{a}</TableCell>
                </TableRow>)}
                {(value.prepMigrationResolution.changeDescription || []).map(a => <TableRow key={"replace." + a}>
                    <TableCell padding="checkbox">
                        <EditIcon />
                    </TableCell>
                    <TableCell>{a}</TableCell>
                </TableRow>)}
            </Table>

            <div style={{height: 32}} />

            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography variant="h6">
                        Setup Equivalent Preps Rule
                    </Typography>
                    <Typography variant="body2">
                        Create a rule on the project to allow this change without having to update
                        the door/frame information we send to the manufacturer.
                    </Typography>
                </Grid><Grid item xs={6}>
                    <Typography variant="h6">
                        Go Back
                    </Typography>
                    <Typography variant="body2">
                        Don't make any changes, go back to my edits so I can correct them.
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="contained" size="small" fullWidth onClick={submit}>Add Preps Rule</Button>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="contained" size="small" fullWidth onClick={() => {
                        setShow(false);
                    }}>Go Back</Button>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog2>)
}

function getMigration(input: any) {
    if(!input) return null;
    if(typeof input !== "object" || !("prepMigrationResolution" in input)) {
        return null;
    }

    return input as PrepMigrationResolution;
}